import { deepCopy } from "../../../../utils/deepCopy";
import { toast } from "../../../../utils/messageUtils";

export const fetchTrendHeatmapQuestionsStarted = (state) => {
    return {
        ...state,
        trendHeatmapQuestionsApi: {
            isProcessing: true,
            error: false
        }
    }

}

export const fetchTrendHeatmapQuestionsSuccess = (state, payload) => {
    let topicQuestions = [];
    let heatmapData = deepCopy(state.trendHeatmapData);
    if (payload.data && payload.data.data) {
        topicQuestions = payload.data.data.dataMap
    }
    if (topicQuestions.length) {
        heatmapData = addTopicQuestionsToTopic({ heatmapData, topicQuestions }, payload.dimension)
    }
    return {
        ...state,
        trendHeatmapQuestionsApi: {
            isProcessing: false,
            error: false
        },
        trendHeatmapData: heatmapData
    }

}

export const fetchTrendHeatmapQuestionsFailed = (state, payload) => {
    toast.error("Failed to fetch questions data.")
    return {
        ...state,
        trendHeatmapQuestionsApi: {
            isProcessing: false,
            error: true
        },
        isDataFetchedTrend: false
    }

}

const addTopicQuestionsToTopic = ({ heatmapData, topicQuestions }, dimension) => {
    const data = heatmapData;
    data.forEach(item => {
        if (item.name === dimension) {
            item.children = topicQuestions
        }
    })
    return data
}